// src/utils/onceLocal.ts
type OncePayload = { ts: number };

const LS_AVAILABLE = (() => {
    try {
        return typeof window !== "undefined" && !!window.localStorage;
    } catch {
        return false;
    }
})();

/** Devuelve true si el flag existe y aún está dentro del TTL */
export function wasShownWithin(key: string, ttlMs: number): boolean {
    if (!LS_AVAILABLE) return false;
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return false;
        const data = JSON.parse(raw) as OncePayload;
        if (!data?.ts) return false;
        return Date.now() - data.ts < ttlMs;
    } catch {
        // Si hay problema de parseo, limpiamos
        try { localStorage.removeItem(key); } catch { }
        return false;
    }
}

/** Marca el flag como “mostrado ahora” */
export function markShownNow(key: string): void {
    if (!LS_AVAILABLE) return;
    try {
        const payload: OncePayload = { ts: Date.now() };
        localStorage.setItem(key, JSON.stringify(payload));
    } catch {
        // Ignorar errores de cuota/etc.
    }
}

/** Ejecuta fn una sola vez por TTL; devuelve true si ejecutó */
export function runOncePer(key: string, ttlMs: number, fn: () => void): boolean {
    if (wasShownWithin(key, ttlMs)) return false;
    fn();
    markShownNow(key);
    return true;
}